const active = ({ successColorPalette }) => successColorPalette[700];

export default active;
